import {action} from 'typesafe-actions';
import {AssetMetaInterface} from '@taopix/taopix-core/dist/types/types';
import {AssetServiceState} from './AssetServicesContext';

export enum AssetServiceActionTypes {
  SET_OPEN_STATE = 'SET_OPEN_STATE',
  SET_SELECTED_ASSETS = 'SET_SELECTED_ASSETS',
  RESET_SELECTED_ASSETS = 'RESET_SELECTED_ASSETS',
  SET_SELECTED_SERVICE = 'SET_SELECTED_SERVICE',
  RESET_SELECTED_SERVICE = 'RESET_SELECTED_SERVICE',
  SET_SERVICE_DIALOG_OPEN_STATE = 'SET_SERVICE_DIALOG_OPEN_STATE',
}

export const AssetServicesActions = {
  setOpenState: (state: Partial<AssetServiceState>) =>
    action(AssetServiceActionTypes.SET_OPEN_STATE, state),
  setSelectedAssets: (assets: AssetMetaInterface[]) =>
    action(AssetServiceActionTypes.SET_SELECTED_ASSETS, assets),
  resetAssets: () => action(AssetServiceActionTypes.RESET_SELECTED_ASSETS),
  setSelectedService: (selectedServiceID: number) =>
    action(AssetServiceActionTypes.SET_SELECTED_SERVICE, selectedServiceID),
  resetSelectedService: () => action(AssetServiceActionTypes.RESET_SELECTED_SERVICE),
  setServiceDialogOpenState: (open: boolean) =>
    action(AssetServiceActionTypes.SET_SERVICE_DIALOG_OPEN_STATE, open),
};
